"use client";

import { useEffect, useState } from "react";
import { getPassData, getSubscriptionData } from "@/app/(general-header)/botb-pass/subscription-service";

/**
 * Content for the end-of-page BOTB Pass widget.
 *
 * Both calls are the ones /botb-pass makes for its own hero and legal note, so
 * whatever the CMS is promoting there shows up here too — the widget has no
 * copy of its own to keep in sync. `getPassData` carries the banner artwork,
 * headline markup and stat tiles; `getSubscriptionData` carries the current
 * offer and the small print underneath.
 *
 * Self-fetching rather than fed from `useLifestylePage`: the widget sits below
 * the prize grid, so it must not hold up the page's loading gate.
 */
export default function useBotBPassWidget() {
  const [passData, setPassData] = useState<BotBPassProps>();
  const [subscriptionData, setSubscriptionData] = useState<PreSubscriptionData>();

  useEffect(() => {
    getPassData()
      .then(response => response.json())
      .then((data: BotBPassProps) => setPassData(data))
      .catch(error => console.error("Error fetching BOTB Pass data:", error));

    getSubscriptionData()
      .then(response => response.json())
      .then((data: PreSubscriptionData) => setSubscriptionData(data))
      .catch(error => console.error("Error fetching pre-subscription data:", error));
  }, []);

  return {
    // The hero is a carousel on /botb-pass; the widget only shows the first.
    banner: passData?.BannerList?.[0],
    milestonesHtml: passData?.BiggerMilestones,
    subscriptionData,
  };
}
